//Welcome screen to home transition
$(document).ready(function () {
  if (window.location.hash) {
    $('header.site-header').hide();
    $('nav').delay(1500).fadeIn(300);

    if (window.location.hash.substr(1).split("_")[0] !== 'your-report') {
      $('#secondary').delay(500).fadeIn(300);
    }
  } else {
    $('.innner_tmpw_outthinklogo').hide();
    //$('.brandLogo-section').fadeOut();
    $('nav').hide();
    $('header.site-header').show();
    $('header.site-header').delay(1500).fadeOut(500);
    $('#home').delay(1500).fadeIn(300);
    $('#secondary').delay(4000).fadeIn(300);
    $('nav').delay(1500).fadeIn(300);
    $('.innner_tmpw_outthinklogo').delay(1500).fadeIn(300);
  //  $('.brandLogo-section').delay(1500).fadeIn(300);
    
  }
});


setTimeout(function () {
  $('body').removeClass('no-scroll');
}, 500);

// Navigation between sections
$('nav ul li').on('click', 'a', function (e) {
    const brandLogoSection = document.querySelector('.brandLogo-section');
    var hash = window.location.hash.substr(1).split("_", 1);
      if (!hash.includes("your-report-breakdown")) {
   // brandLogoSection.style.display = "flex";
      }
    $('.widget-area').fadeOut(0);
  $('nav ul li').removeClass('active');
  $(this).parent().addClass('active');
  var currentSection = $(this).attr('href').slice(1);
  $("html").animate({ scrollTop: 0 }, 0);
  
  var parentElement = document.querySelector('.brandLogo-section');
  // var element = document.querySelector('.brandLogo-section .outthink-colors-animation-container #circle');
  // var elementCenterContent = document.querySelector('.brandLogo-section .outthink-colors-animation-container .center-content');
  // var mobile_innner_tmpw_outthinklogo = document.querySelector('.mobile_innner_tmpw_outthinklogo');
  // var h4Element = mobile_innner_tmpw_outthinklogo.querySelector('h4');
  // var aElement = mobile_innner_tmpw_outthinklogo.querySelector('a');
 
  if (!$(this).parent().hasClass('home-link')) {
    // element.style.display = 'none';  
    if (window.innerWidth <= 960) {
      //elementCenterContent.style.display = 'none'; 
      // h4Element.style.display = 'block'; 
      // aElement.style.display = 'none'; 
    }
   // parentElement.style.marginBottom  = '-376px';
    e.preventDefault();
  } else {
   // element.style.display = 'block';  
    if (window.innerWidth <= 960) {
      //elementCenterContent.style.display = 'block'; 
      // h4Element.style.display = 'none'; 
      // aElement.style.display = 'block'; 
    } 
   // parentElement.style.marginBottom  = '-277px';
    e.preventDefault();
  }

  if (!$(this).parent().hasClass('download-link')) {
    location.hash = $(this).attr('href');  
    e.preventDefault();
  }
});

$('.nextpage').on('click', function (e) {
  var currentPage = $(this).attr('href').slice(1);
  var parentElement = document.querySelector('.brandLogo-section');
  // var element = document.querySelector('.brandLogo-section .outthink-colors-animation-container #circle');
  // var elementCenterContent = document.querySelector('.brandLogo-section .outthink-colors-animation-container .center-content');
  // var mobile_innner_tmpw_outthinklogo = document.querySelector('.mobile_innner_tmpw_outthinklogo');
  // var h4Element = mobile_innner_tmpw_outthinklogo.querySelector('h4');
  // var aElement = mobile_innner_tmpw_outthinklogo.querySelector('a');
 // elementCenterContent.style.display = 'none'; 
      // h4Element.style.display = 'block'; 
      // aElement.style.display = 'none'; 
  $('nav ul li').removeClass('active');
  var currentMenu = $('nav ul li a[href="#' + currentPage + '"]');
  currentMenu.parent().addClass('active');
  // element.style.display = 'none';  
  //parentElement.style.marginBottom  = '-376px';
   // console.log(currentMenu);
  // $('.fullscreen-section').fadeOut(500);
  // $('#' + currentPage).fadeIn(500);
  location.hash = $(this).attr('href');
  e.preventDefault();
});

function pha_childPieChart(stageValue, stageClass, type="progress") {
  //console.log(stageValue, stageClass, type);
 
  var game = { score: 0 },
  scoreDisplay = document.querySelector('.' + stageClass + ' .child_progress_score_display');
var scoreValue = '+' + stageValue;
var stokeValue = Math.floor(300 * stageValue / 100);
// console.log(stokeValue);
var colorFOr = '';
let svgselector = "";
if(type == "report"){
   svgselector = "."+stageClass+" .report_child_animate1";
   colorFOr = "_stage1";
}
else{
   svgselector = "."+stageClass+" .progress_child_animate1";
}

// console.log(svgselector);
$(svgselector).css("stroke-dasharray", "0 300");
if (stageValue) {
  $(svgselector).css("stroke", "url(#linear-gradient85_report" + colorFOr + ")");
}

function updateHandler() {
  scoreDisplay.innerHTML = game.score;
}
var c1Section3 = new TimelineLite();
c1Section3.from(svgselector, 3, { "stroke-dasharray": "0 300", ease: Expo.easeNone }, 0)
c1Section3.to(svgselector, 3, { "stroke-dasharray": stokeValue + " 300", ease: Expo.easeNone }, 0)
  .to(game, 3, {
    score: scoreValue,
    roundProps: "score",
    onUpdate: updateHandler,
    ease: Expo.easeNone
  }, 0);
}

function childPieChart(stageValue, stageClass, type="progress") {
  //console.log(stageValue, stageClass, type);
  
  var game = { score: 0 },
    scoreDisplay = document.querySelector('.' + stageClass + ' .child_progress_score_display');
  var scoreValue = '+' + stageValue;
  var stokeValue = Math.floor(300 * stageValue / 100);
  // console.log(stokeValue);
  var colorFOr = '';
  let svgselector = "";
  if(type == "report"){
     svgselector = "."+stageClass+" .report_child_animate1";
     colorFOr = "_stage";
  }
  else{
     svgselector = "."+stageClass+" .progress_child_animate1";
  }
  
  // console.log(svgselector);
  $(svgselector).css("stroke-dasharray", "0 300");
  if (stageValue > 66) {
    $(svgselector).css("stroke", "url(#linear-gradient85_report" + colorFOr + ")");
    // $('#' + stageClass + '_Path_200').css("fill", "#A2D23F");
    // $('#' + stageClass + '_pie_Path_200').css("fill", "#A2D23F");
  }
  else if (66 > stageValue && stageValue > 33) {
    $(svgselector).css("stroke", "url(#linear-gradient66_report" + colorFOr + ")");
    // $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_orange)");
    // $('#' + stageClass + '_pie_Path_200').css("fill", "url(#" + stageClass + "_pie_info_orange)");
  }
  else {
    $(svgselector).css("stroke", "url(#linear-gradient33_report" + colorFOr + ")");
    // $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_pink)");
    // $('#' + stageClass + '_pie_Path_200').css("fill", "url(#" + stageClass + "_pie_info_pink)");
  }

  function updateHandler() {
    scoreDisplay.innerHTML = game.score;
  }
  var c1Section3 = new TimelineLite();
  c1Section3.from(svgselector, 3, { "stroke-dasharray": "0 300", ease: Expo.easeNone }, 0)
  c1Section3.to(svgselector, 3, { "stroke-dasharray": stokeValue + " 300", ease: Expo.easeNone }, 0)
    .to(game, 3, {
      score: scoreValue,
      roundProps: "score",
      onUpdate: updateHandler,
      ease: Expo.easeNone
    }, 0);
}
//chart 
function pieChart(stageValue, stageClass) {
  var game = { score: 0 },
    scoreDisplay = document.querySelector('.' + stageClass + '_score-1');
  var scoreValue = '+' + stageValue;
  var stokeValue = Math.floor(300 * stageValue / 100);
  
  var colorFOr = '';
  if (stageClass == 'report') {
    colorFOr = "_stage";
  }
  else if (stageClass == 'nextStep') {
    colorFOr = "_nextStep";
  }

  $('.' + stageClass + '_animate1').css("stroke-dasharray", "0 300");
  $('.' + stageClass + '_animate1').css("stroke", "url(#linear-gradient85_report" + colorFOr + ")");
  $('#' + stageClass + '_Path_200').css("fill", "#A2D23F");
  $('#' + stageClass + '_pie_Path_200').css("fill", "#A2D23F");

  function updateHandler() {
    scoreDisplay.innerHTML = game.score;
  }
  var c1Section3 = new TimelineLite();
  c1Section3.from('.' + stageClass + '_animate1', 3, { "stroke-dasharray": "0 300", ease: Expo.easeNone }, 0)
  c1Section3.to('.' + stageClass + '_animate1', 3, { "stroke-dasharray": stokeValue + " 300", ease: Expo.easeNone }, 0)
    .to(game, 3, {
      score: scoreValue,
      roundProps: "score",
      onUpdate: updateHandler,
      ease: Expo.easeNone
    }, 0);
    
}

$('.total-score-menu').on('click', function (e) {
  pieChart($('.progress_score-1').html(), 'progress');
  numCounter($('#progress_score-2').html(), 'progress');
  let other_child_brands = document.querySelectorAll(".other_child_brands .pie-holder");
  if(other_child_brands){
    for(let i = 0; i < other_child_brands.length; i++){
      let child_score = 0;
      if(other_child_brands[i].hasAttribute("data-totalscore")){
        child_score = other_child_brands[i].getAttribute("data-totalscore");
      }
      let child_class = other_child_brands[i].classList;
      let newclasslist = [...child_class];
      const newclasslistindex = newclasslist.indexOf("pie-holder");
if (newclasslistindex > -1) { // only splice array when item is found
  newclasslist.splice(newclasslistindex, 1); // 2nd parameter means remove one item only
}
      childPieChart(child_score,newclasslist[0]);
    }
  }
  
  
});

$('.nextStep-menu').on('click', function (e) {
  pieChart($('.nextStep_score-1').html(), 'nextStep');
  numCounter($('#nextStep_score-2').html(), 'nextStep');
});

$('.nextpagecontact').on('click', function (e) {
  pieChart($('.nextStep_score-1').html(), 'nextStep');
  numCounter($('#nextStep_score-2').html(), 'nextStep');
});


function numCounter(stageValue, stageClass) {
  return false;
  if (stageValue < 2) {
    $('#' + stageClass + '_Path_1114').css("fill", "#009245");
    $('#' + stageClass + '_color_dot path').css("fill", "#0072FE");
    $('#' + stageClass + '_Path_200').css("fill", "#A2D23F");
  }
  else if (4 > stageValue && stageValue > 1) {
    $('#' + stageClass + '_Path_1114').css("fill", "#F7931E");
    $('#' + stageClass + '_color_dot path').css("fill", "#FDC600");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_orange)");
  }
  else {
    $('#' + stageClass + '_Path_1114').css("fill", "#9E005D");
    $('#' + stageClass + '_color_dot path').css("fill", "#FD4B00");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_pink)");
  }

  var counter = 0;
  var maxValue = stageValue;
  var nc0 = '#' + stageClass + '_score-2';
  var nc1 = '#' + stageClass + '_score-2_swap';
  var n0 = document.querySelector(nc0);
  var n1 = document.querySelector(nc1);

  countDown();
  function countDown() {
    if (counter < maxValue) {
      counter++;
      n1.textContent = counter;
      TweenMax.to(nc0, 0.1, {
        y: "20-=70",
        delay: 0.1,
        ease: Power3.easeInOut,
        onComplete: swapNodes
      });
    }
  }

  function swapNodes() {
    n0.textContent = counter;
    TweenMax.set(nc0, { y: "20+=70", onComplete: countDown });
  }
}


$('.your-report-menu').on('click', function (e) {
  let yourReport = document.querySelector(".your-report");
  var yourreportbreakdown = document.getElementById('your-report-breakdown');
  var yourReportbyid = document.getElementById('your-report');
  //document.querySelector('.brandLogo-section').style.setProperty('display', 'none', 'important');
  if(!yourReport){
    return false;
  }
  // $('.your-report-breakdown').fadeIn(300);
  // $('.your-report').fadeIn(300);
    yourReport.style.opacity = "1";
    yourReport.style.display = "block";
    yourreportbreakdown.style.display = 'block';
    yourReportbyid.style.display = 'none';
  let buttonGroup = yourReport.querySelectorAll(".button-group button");
  if(!buttonGroup){
    return false;
  }
  let reportmainscore = buttonGroup[0].getAttribute("data-singlebrand")??0;
  pieChart(reportmainscore, 'report');
 // numCounter(reportmainscore, 'report');
  let other_child_brands = document.querySelectorAll(".other_child_brands_breakdown .pie-holder");
  if(other_child_brands){
    for(let i = 0; i < other_child_brands.length; i++){
      let child_score = 0;
      if(other_child_brands[i].hasAttribute("data-totalscore")){
        child_score = other_child_brands[i].getAttribute("data-totalscore");
      }
      let child_class = other_child_brands[i].classList;
      let newclasslist = [...child_class];
      const newclasslistindex = newclasslist.indexOf("pie-holder");
if (newclasslistindex > -1) { // only splice array when item is found
  newclasslist.splice(newclasslistindex, 1); // 2nd parameter means remove one item only
}
pha_childPieChart(child_score,newclasslist[0], "report");
    }
  }
});

function nextSec() {
  $("html").animate({ scrollTop: 0 }, 0);
  $('.active-stage').next().trigger('click');
  updateButtonGroupVisibility();
}

function prevSec() {
  $("html").animate({ scrollTop: 0 }, 0);
  $('.active-stage').prev().trigger('click');
  updateButtonGroupVisibility();
}

function updateButtonGroupVisibility() {
  if ($('.button-group button:last-child').hasClass('active-stage')) {
    $('.prevnext .nextsec').fadeOut(0);
   // $('.your-report').fadeOut(50);
   // $('.widget-area').fadeIn(50);
   // $('.nextpagecontact').fadeIn(200).css('display', 'block');
  } else {
    $('.prevnext .nextsec').fadeIn(50);
    $('.nextpagecontact').fadeOut(0).css('display', 'none');
   // $('.your-report').fadeIn(50);
   // $('.widget-area').fadeOut(50);
  }

  if ($('.button-group button:first-child').hasClass('active-stage')) {
    $('#prev-sec').hide();
  } else {
    $('#prev-sec').show();
  }
}

$('.download-link').on('click', 'a', function (e) {
  //e.preventDefault()
});

// if (window.location.hash) {
//   var crnthash = window.location.hash.substr(1).split('_')[0];
//   if (window.location.hash.indexOf('_') != -1) {
//     var n = window.location.hash.split("_");
//     var result = n[n.length - 1];
//   }

//   if (crnthash == 'your-report') {
//     $('.button-group').hide();
//     $('#secondary').hide();
//   } else {
//     $('.button-group').show(); // Ensure this aligns with CSS rules
//   }

//   $('.fullscreen-section').fadeOut(1);
//   $('#' + crnthash).fadeIn(500);

//   $("html").animate({ scrollTop: 0 }, 200);
//   $('nav ul li').removeClass('active');
//   $('a[href=#' + crnthash + ']').parent().addClass('active');

//   setTimeout(function () {
//     if (crnthash == 'total-score') {
//       pieChart($('.progress_score-1').html(), 'progress');
//       numCounter($('#progress_score-2').html(), 'progress');
//     } else if (crnthash == 'your-report') {
//       $('#secondary').hide();
//       if (window.location.hash.indexOf('_') != -1) {
//         pieChart($("." + result + '-score').html(), 'report');
//         numCounter($("." + result + '-critical').html(), 'report');
//         $('#secondary').hide();
//       } else {
//         pieChart($("." + firstStage + '-score').html(), 'report');
//         numCounter($("." + firstStage + '-critical').html(), 'report');
//         $('#secondary').hide();
//       }
//     } else if (crnthash == 'contact') {
//       pieChart($('.nextStep_score-1').html(), 'nextStep');
//       numCounter($('#nextStep_score-2').html(), 'nextStep');
//     }
//   }, 2);

//   if (result !== '') {
//     $('#' + result).click();
//   }
// }

window.onhashchange = function () {
  var hashmain = window.location.hash;
  var hash = window.location.hash.substr(1).split("_", 1);
  if (window.location.hash.substr(1).split("_")[1] == null) {
    if (!hash.includes("contact-link")) {
   $('.fullscreen-section').fadeOut(0);
    $('#' + hash).fadeIn(500);
    $("html").animate({ scrollTop: 0 }, 0);
    $('nav ul li').removeClass('active');
    $('a[href=#' + hash + ']').parent().addClass('active');
    }
  }


  if (window.location.hash.substr(1).split("_")[0] == 'your-report') {
    //$('#secondary').hide();
  } else {
  //  $('#secondary').show();
  }
  if (window.location.hash.substr(1).split("_")[0] == 'home') {
    $('#secondary').hide();
    $('.mobile_innner_tmpw_outthinklogo').hide();
  }
  if (window.location.hash.substr(1).split("_")[0] != 'home') {
    $('.mobile_innner_tmpw_outthinklogo').hide();
    $('#secondary').hide();
  }
  if (window.location.hash.substr(1).split("_")[0] == 'related-articles') {
    $('#secondary').show();
  }
  if (window.location.hash.substr(1).split("_")[0] == 'total-score'){
    document.body.classList.remove('ps_body_mobile');
  } else {
    document.body.classList.add('ps_body_mobile');
  }
  if (window.location.hash.substr(1).split("_")[0] == 'total-score' || window.location.hash.substr(1).split("_")[0] == 'your-report-breakdown'  || window.location.hash.substr(1).split("_")[0] == 'your-report') {
   if(window.innerWidth <= 960){
   // document.querySelector('.brandLogo-section').style.display = 'none';
   }
  } else {
    if(window.innerWidth <= 960){
   // document.querySelector('.brandLogo-section').style.display = 'flex';
    }
  }
};

document.addEventListener("scroll", function() {
  const el = document.querySelector(".button-group");
  const ref = document.querySelector(".current-stage-title-cont");
  let rect = ref.getBoundingClientRect();
  if (rect.top <= 0) {
    el.classList.add("sticky-right");
  } else {
    el.classList.remove("sticky-right");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  // hide fulscreen on load
  let sectionsF = document.querySelectorAll(".fullscreen-section");
  if(sectionsF){
    for(let i =0; i< sectionsF.length; i++){
      setTimeout(() => {
        sectionsF[i].style.display= "none";
      }, 1);
      
    }
  }
  const colors = ["svgcolor1", "svgcolor2", "svgcolor3", "svgcolor4", "svgcolor5"];
  let colorIndex = 0;

  // Function to add a unique class to the SVG
  function addClassToSVG(svg) {
    const uniqueClass = colors[colorIndex % colors.length];
    svg.classList.add(uniqueClass);
    colorIndex++;
  }

  // Apply unique class to all SVGs in the DOM
  let all_svgs_colored = document.querySelectorAll('.other_brand .pie-holder svg');

  if (all_svgs_colored.length > 0) {
    all_svgs_colored.forEach(svg => {
      addClassToSVG(svg);
    });
  } else {
    console.warn('No SVGs found to apply colors.');
  }
});

// animated circle work
let colors;  // Declare the 'colors' variable outside the if/else block

if (document.body.classList.contains('page-template-outthink-tool-template')) {
  colors = ["#FFFF1A", "#50FFD1", "#57C6DB", "#FFFFFF"];  
} else {
  colors = ["#FB67EA", "#8AC700", "#353535", "#67C9BD", "#FEFE00", "#212B4F", "#51FFC1", "#FFFF1A", "#F5A0C1", "#272727", "#ffffff"]; 
}


function createDot(circle, color, angle) {
    const radius = circle.offsetWidth / 2;
    const dot = document.createElement('div');
    dot.className = 'dot';
    dot.style.backgroundColor = color;
    dot.style.width = `${Math.random() * 1.5 + 2}px`;  // Smaller dots
    dot.style.height = dot.style.width;
    const distance = radius - 30 + Math.random() * 40;  // Expanded radius area
    const x = radius + distance * Math.cos(angle) - dot.offsetWidth / 2;
    const y = radius + distance * Math.sin(angle) - dot.offsetHeight / 2;
    dot.style.left = `${x}px`;
    dot.style.top = `${y}px`;
    dot.style.setProperty('--random-opacity', Math.random());
    dot.style.setProperty('--random-duration', `${Math.random() * 2 + 1}s`);
    dot.style.setProperty('--random-delay', `${Math.random() * 2}s`);
    circle.appendChild(dot);

    const line = document.createElement('div');
    line.className = 'line';
    const lineLength = Math.sqrt((x - radius) ** 2 + (y - radius) ** 2);
    line.style.height = `${lineLength - 10}px`;
    line.style.transform = `rotate(${angle}rad)`;
    line.style.transformOrigin = 'top center';
    line.style.left = `${radius}px`;
    line.style.top = `${radius}px`;
    line.style.backgroundColor = color;
    circle.appendChild(line);
}

function createDotsForCircle(circle) {
    const totalDots = 400;
    const dotsPerColor = 50;
    let dotCount = 0;

    for (let i = 0; i < totalDots; i++) {
        const colorIndex = Math.floor(dotCount / dotsPerColor) % colors.length;
        const color = colors[colorIndex];
        const angle = Math.random() * 2 * Math.PI;
        createDot(circle, color, angle);
        dotCount++;
    }
}

function initingCircles(){
  let circles = document.querySelectorAll('.circle');
if(circles){
  circles.forEach(circle => {
    createDotsForCircle(circle);
  });
}
}


document.addEventListener("DOMContentLoaded", (event) => {
  initingCircles();
  ps_tabbing_repeater();
  ps_breakdown_tabbing_repeater();
  ps_checkHash();
  ps_share_btn();
  psSplashScreen();
  psshowarticles();
});

function ps_tabbing_repeater(){
  const buttons = document.querySelectorAll(".your-report .button-group button");
  const buttonsLength = buttons.length;
  const prevButton = document.querySelector(".your-report #prev-sec");
  const nextButton = document.querySelector(".your-report #next-sec");
  const prevButtonsvg = document.querySelector(".your-report #prev-sec svg");
  const nextButtonsvg = document.querySelector(".your-report #next-sec svg");
  const backprevButton = document.getElementById("back-prev-sec");
  const backnextButton = document.getElementById("back-next-sec");
  const backprevButtonsvg = document.querySelector("#back-prev-sec svg");
  const backnextButtonsvg = document.querySelector("#back-next-sec svg");
  const currentStageTitle = document.querySelector('.your-report .current-stage-title');

  let activeIndex = 0;

  function showTab(index) {
    // Deactivate all buttons
    buttons.forEach((button, i) => {
        button.classList.toggle("active-stage", i === index);
    });

    activeIndex = index;
    
  if (activeIndex === 0) {
    //console.log('yes');
    prevButton.style.visibility = "hidden";
    prevButton.style.setProperty("display", "flex", "important");
    backprevButton.style.visibility = "visible";
    backprevButton.style.setProperty("display", "flex", "important");
    prevButtonsvg.style.setProperty("display", "none", "important");
    backnextButtonsvg.style.setProperty("display", "none", "important");
  } else {
    //console.log('no');
    prevButton.style.visibility = "visible";
     // nextButton.style.setProperty("display", "flex", "important");
     backprevButton.style.visibility = "hidden";
     backprevButton.style.setProperty("display", "none", "important");
     prevButtonsvg.style.setProperty("display", "block", "important");
     nextButtonsvg.style.setProperty("display", "block", "important");
     backnextButtonsvg.style.setProperty("display", "block", "important");
  }
    // Handle next button visibility
    if (activeIndex === (buttonsLength - 1)) {
       // console.log("if");
        nextButton.style.visibility = "hidden";
        nextButton.style.setProperty("display", "flex", "important");
        nextButton.classList.add("your-report-hidden-class");
        backnextButton.style.visibility = "visible";
        backnextButton.style.setProperty("display", "flex", "important");
    } else {
       // console.log("else");
        nextButton.style.visibility = "visible";
        nextButton.classList.remove("your-report-hidden-class");
       // nextButton.style.setProperty("display", "flex", "important");
        backnextButton.style.visibility = "hidden";
        backnextButton.style.setProperty("display", "none", "important");
    }

    // Update counter
    const counterDiv = document.getElementById("counter");
    let currentbtnsection = activeIndex + 1;
    counterDiv.innerHTML = '<span class="title-count-first">' + currentbtnsection + '</span><span class="title-count-middle">/</span><span class="title-count-last">' + buttons.length + '</span>';
}


  const ps_score_tool_tip = document.querySelector('.your-report .tooltiptext .current-stage-score-tt');
  const defaultscoretooltipValue = buttons[0].dataset.scoretooltip;
  if(ps_score_tool_tip){
    ps_score_tool_tip.textContent = defaultscoretooltipValue;
  }
  // Add event listeners to buttons
  buttons.forEach((button, i) => {
      button.addEventListener("click", (event) => {
          showTab(i);
          const clickedButton = event.currentTarget;
          const singleBrandValue = clickedButton.dataset.singlebrand;
          const scoretooltipValue = clickedButton.dataset.scoretooltip;
          const buttonText = clickedButton.textContent.trim();
          const otherbrands = clickedButton.dataset.otherbrand.split(',').map(value => value.trim());
          if (currentStageTitle) {
            currentStageTitle.textContent = buttonText;
        }
        if(ps_score_tool_tip){
          ps_score_tool_tip.textContent = scoretooltipValue;
        }
          // Loop through the element IDs and set their content
          otherbrands.forEach((id, index) => {
            // Get the element by ID
            let adjustedIndex = index + 1;
            const pselement = document.querySelector('.other_your_report_child_brands_breakdown .progress_score1-1'+adjustedIndex);
            if (pselement) {
              pselement.textContent = id;
            }
            childPieChart(id,"pha-"+index, "report");
        });
          pieChart(singleBrandValue, 'report');
          numCounter(singleBrandValue, 'report');

          
          // pieChart(56, 'progress');
          // numCounter(56, 'progress');
      });
  });

  // Add event listeners for Prev and Next buttons
  prevButton.addEventListener("click", (e) => {
    e.preventDefault();
      if (activeIndex > 0) {
          showTab(activeIndex);
      }
  });

  nextButton.addEventListener("click", (e) => {
    e.preventDefault();
      if (activeIndex < buttons.length - 1) {
      //  console.log(activeIndex);
          showTab(activeIndex);
      }
  });

  // Initialize the first tab as active
  showTab(activeIndex);
}

// Function to check if the URL contains #home
function ps_checkHash() {
  // Get the current URL hash (including the #)
  var currentHash = window.location.hash;

  // var element = document.querySelector('.brandLogo-section .outthink-colors-animation-container #circle');
  // var elementCenterContent = document.querySelector('.brandLogo-section .outthink-colors-animation-container .center-content');
  // // var mobile_innner_tmpw_outthinklogo = document.querySelector('.mobile_innner_tmpw_outthinklogo');
  // // var h4Element = mobile_innner_tmpw_outthinklogo.querySelector('h4');
  // // var aElement = mobile_innner_tmpw_outthinklogo.querySelector('a');
  // var parentElement = document.querySelector('.brandLogo-section');
  // Check if the hash matches #home
  if (currentHash === '#home' || currentHash === '') {
         
    setTimeout(() => {
   // element.style.display = 'block'; 
    if (window.innerWidth <= 960) {
    //elementCenterContent.style.display = 'block'; 
        // h4Element.style.display = 'none'; 
        // aElement.style.display = 'block';
    }
  }, 2);
  } else {
    setTimeout(() => {
       
   // element.style.display = 'none'; 
    if (window.innerWidth <= 960) {
      //parentElement.style.marginBottom  = '-376px'; 
//elementCenterContent.style.display = 'none'; 
        // h4Element.style.display = 'block'; 
        // aElement.style.display = 'none';
    }
  }, 2);
  }
  if(currentHash === '#home' || currentHash === ''){
    setTimeout(() => {
    document.getElementById('home').style.display = 'block';
    if (window.innerWidth <= 960) {
    //document.querySelector('.brandLogo-section').style.display = 'flex';
    document.body.classList.add('ps_body_mobile');
    }
  }, 2);
  } else if(currentHash === '#total-score'){
    setTimeout(() => {
    document.getElementById('total-score').style.display = 'block';
    document.querySelector('.mobile_innner_tmpw_outthinklogo').style.display = 'none';
    if (window.innerWidth <= 960) {
  //  document.querySelector('.brandLogo-section').style.display = 'none';
    document.body.classList.remove('ps_body_mobile');
    }
  }, 2);
  } else if(currentHash === '#your-report'){
    setTimeout(() => {
      document.getElementById('your-report').style.display = 'block';
      document.querySelector('.mobile_innner_tmpw_outthinklogo').style.display = 'none';
      if (window.innerWidth <= 960) {
      //document.querySelector('.brandLogo-section').style.display = 'flex';
      document.body.classList.add('ps_body_mobile');
      }
    }, 2);
    
  } else if(currentHash === '#your-report-breakdown'){
    setTimeout(() => {
      document.getElementById('your-report-breakdown').style.display = 'block';
      document.querySelector('.mobile_innner_tmpw_outthinklogo').style.display = 'none';
      if (window.innerWidth <= 960) {
     // document.querySelector('.brandLogo-section').style.display = 'none';
      document.body.classList.add('ps_body_mobile');
      }
    }, 2);
    
  } 
}

document.addEventListener('DOMContentLoaded', function() {
  // Step 1: Get all .widget.widget_block elements
  var widgetBlocks = document.querySelectorAll('.widget.widget_block');

  // Loop through each .widget.widget_block element
  widgetBlocks.forEach(function(widgetBlock) {
      // Find the existing <a> tag within this widget block
      var existingLink = widgetBlock.querySelector('a');
      if (existingLink) {
          // Add tabindex="-1" to the existing <a> tag
          existingLink.setAttribute('tabindex', '-1');
          
          // Retrieve the href attribute
          var hrefValue = existingLink.getAttribute('href');

          // Find the <div class="wp-block-cover"> within this widget block
          var wpBlockCover = widgetBlock.querySelector('.wp-block-cover');
          if (wpBlockCover) {
              // Create a new <a> tag
              var newLink = document.createElement('a');
              newLink.setAttribute('href', hrefValue);

              // Wrap the <div> with the new <a> tag
              wpBlockCover.parentNode.insertBefore(newLink, wpBlockCover);
              newLink.appendChild(wpBlockCover);
          }
      }
  });
});

function ps_share_btn(){
document.getElementById('shareButton').onclick = function() {
  const currentUrl = window.location.href; // Get the current URL
  if (navigator.share) {
      // If the Web Share API is supported
      navigator.share({
          title: document.title, // Title of the page
          url: currentUrl // URL to share
      })
      .then(() => console.log('Share successful'))
      .catch(error => console.error('Error sharing:', error));
  } else {
      // Fallback for browsers that do not support the Web Share API
      alert('Sharing not supported. Here is the URL: ' + currentUrl);
  }
};
}

function psSplashScreen(){
  // Function to hide splash screen and show main content
  function hideSplashScreen() {
    document.getElementById('splash-screen').style.display = 'none';
    document.getElementById('page').style.visibility = 'visible';
}

// Show the splash screen for 5 seconds, then hide it
setTimeout(hideSplashScreen, 2000);
}


function psshowarticles(){
    const backNextSec = document.getElementById("back-next-sec");
    const yourReport = document.querySelector('.your-report');
    const widgetArea = document.querySelector('.widget-area');
    const brandLogoSection = document.querySelector('.brandLogo-section');
    
    backNextSec.addEventListener("click", function() {
        // Fade out yourReport
        yourReport.style.transition = "opacity 0.05s";
        yourReport.style.opacity = "0";
       // brandLogoSection.style.display = "none";
        // Wait for the fade-out to complete before fading in widgetArea
        setTimeout(function() {
            yourReport.style.display = "none"; // Hide after fade out
            widgetArea.style.display = "block"; // Show widgetArea
            widgetArea.style.opacity = "0"; // Start invisible
            widgetArea.style.transition = "opacity 0.05s";
            widgetArea.style.opacity = "1"; // Fade in
        }, 50); // Match this duration with the fade-out time
    });

}

document.addEventListener("DOMContentLoaded", function() {
  const widgetArea = document.querySelector('.widget-area');
  const relatedArticlesLink = document.querySelector('.ps_related_articles_link');
  var yourreportbreakdown = document.getElementById('your-report-breakdown');
  var yourReport = document.getElementById('your-report');
  // Check if the related articles link exists before adding the event listener
  if (relatedArticlesLink) {
      relatedArticlesLink.addEventListener("click", function() {
          // Hide the widget area when the link is clicked
         // document.querySelector('.brandLogo-section').style.visibility = 'visible';
          yourreportbreakdown.style.display = 'none';
          yourReport.style.display = 'block';
         // document.querySelector('.brandLogo-section').style.display = 'flex';
          widgetArea.style.display = "none"; // or use widgetArea.style.visibility = "hidden";
      });
  }
});


// Function to check the window width and add/remove a class
function checkWindowSize() {
  if (window.innerWidth <= 960) {
      // Add the 'mobile' class to the body when the width is 960px or below
      document.body.classList.add('ps_body_mobile');
  } else {
      // Remove the 'mobile' class when the width is greater than 960px
      document.body.classList.remove('ps_body_mobile');
  }
}

// Run the function on page load
window.onload = checkWindowSize;

// Run the function on window resize to check for dynamic changes
window.onresize = checkWindowSize;


function ps_breakdown_tabbing_repeater() {
  const buttons = document.querySelectorAll(".your-report .button-group button");
  const buttonsLength = buttons.length;
  const pieHolders = document.querySelectorAll(".ps_client_data_breakdown .pie-holder");
  const pieHoldersLength = pieHolders.length;
  const prevButton = document.querySelector(".your-report #prev-sec");
  const nextButton = document.querySelector(".your-report #next-sec");
  const prevButtonsvg = document.querySelector(".your-report #prev-sec svg");
  const nextButtonsvg = document.querySelector(".your-report #next-sec svg");
  const backprevButton = document.getElementById("back-prev-sec");
  const backnextButton = document.getElementById("back-next-sec");
  const backprevButtonsvg = document.querySelector("#back-prev-sec svg");
  const backnextButtonsvg = document.querySelector("#back-next-sec svg");
  const currentStageTitle = document.querySelector('.your-report .current-stage-title');
  var yourreportbreakdown = document.getElementById('your-report-breakdown');
  var yourReport = document.getElementById('your-report');
  let activeIndex = 0;

  function showTab(index) {
      // Deactivate all pie-holder elements
      pieHolders.forEach((pieHolder, i) => {
          pieHolder.classList.toggle("active-stage1", i === index);
      });

      // Deactivate all buttons
    buttons.forEach((button, i) => {
      button.classList.toggle("active-stage", i === index);
  });

      activeIndex = index;

      // Handle previous button visibility
      if (activeIndex === 0) {
          prevButton.style.visibility = "hidden";
          prevButton.style.setProperty("display", "flex", "important");
          backprevButton.style.visibility = "visible";
          backprevButton.style.setProperty("display", "flex", "important");
          prevButtonsvg.style.setProperty("display", "none", "important");
          backnextButtonsvg.style.setProperty("display", "block", "important");
          backprevButtonsvg.style.setProperty("display", "block", "important");
      } else {
          prevButton.style.visibility = "visible";
          backprevButton.style.visibility = "hidden";
          prevButtonsvg.style.setProperty("display", "block", "important");
          nextButtonsvg.style.setProperty("display", "block", "important");
          backnextButtonsvg.style.setProperty("display", "block", "important");
          backprevButtonsvg.style.setProperty("display", "none", "important");
      }

   
      // Update counter
      const counterDiv = document.getElementById("counter");
      let currentbtnsection = activeIndex + 1;
      counterDiv.innerHTML = '<span class="title-count-first">' + currentbtnsection + '</span><span class="title-count-middle">/</span><span class="title-count-last">' + pieHolders.length + '</span>';
  }

  const ps_score_tool_tip = document.querySelector('.your-report .tooltiptext .current-stage-score-tt');
  const defaultscoretooltipValue = pieHolders[0].dataset.scoretooltip;
  if (ps_score_tool_tip) {
      ps_score_tool_tip.textContent = defaultscoretooltipValue;
  }

  // Add event listeners to pie-holder elements
  pieHolders.forEach((pieHolder, i) => {
      pieHolder.addEventListener("click", (event) => {
        yourreportbreakdown.style.display = 'none';
        yourReport.style.display = 'block';
          showTab(i);
          const clickedPieHolder = event.currentTarget;
          const singleBrandValue = clickedPieHolder.dataset.singlebrand;
          const scoretooltipValue = clickedPieHolder.dataset.scoretooltip;
          const pieHolderText = clickedPieHolder.querySelector('.ps_brand_title').textContent.trim();
          const otherbrands = clickedPieHolder.dataset.otherbrand.split(',').map(value => value.trim());
          if (pieHolderText === "Values and Proposition") {
            backnextButtonsvg.style.setProperty("display", "block", "important");
            backnextButton.style.visibility = "visible";
            backnextButton.style.setProperty("display", "block", "important");
            nextButtonsvg.style.setProperty("display", "none", "important");
            nextButton.style.visibility = "hidden";
        } 

          if (currentStageTitle) {
              currentStageTitle.textContent = pieHolderText;
          }
          if (ps_score_tool_tip) {
              ps_score_tool_tip.textContent = scoretooltipValue;
          }

          // Loop through the element IDs and set their content
          otherbrands.forEach((id, index) => {
              let adjustedIndex = index + 1;
              const pselement = document.querySelector('.other_your_report_child_brands_breakdown .progress_score1-1' + adjustedIndex);
              if (pselement) {
                  pselement.textContent = id;
              }
              childPieChart(id, "pha-" + index, "report");
          });
         
          pieChart(singleBrandValue, 'report');
          numCounter(singleBrandValue, 'report');
      });
  });

  // Add event listeners for Prev and Next buttons
  prevButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (activeIndex > 0) {
          showTab(activeIndex - 1);
      }
  });

  nextButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (activeIndex < pieHoldersLength - 1) {
          showTab(activeIndex + 1);
      }
  });

  // Initialize the first tab as active
  showTab(activeIndex);
}


/**
 * Function to check URL hash and log appropriate message
 * Runs only if body has the class 'page-template-outthink-tool-template'
 */
function checkUrlOnLoadAndChange() {
  // Check if body has the required class
  if (document.body.classList.contains('page-template-outthink-tool-template') || document.body.classList.contains('page-template-default')) {
      
      // Function to check URL and log to console
      function checkUrl() {
        var brandLogoSection = document.querySelector('.brandLogo-section');
        if (brandLogoSection) {
          if (window.location.hash === '#home' || window.location.hash === '') {
              // its home sections 
              // if something needs to be done here
              brandLogoSection.style.visibility = 'visible';
          } else {
               // Select the div with the class 'brandLogo-section'
              
              
              // Check if the div exists
              
                  // Set the display property to 'none' to hide the div
                  brandLogoSection.style.visibility = 'hidden';
              
          }
        }
      }

      // Run checkUrl on page load
      checkUrl();

      // Add event listener for URL changes
      window.addEventListener('hashchange', checkUrl);
  }
}

// Too many existing DOMContentLoaded event listener 
// creating a new one to prevent confusion
document.addEventListener('DOMContentLoaded', function() {
  checkUrlOnLoadAndChange();
});